import React from 'react';
import Icon from './Icon';

const FilterIcon = (props) => (
    <Icon {...props}>
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </Icon>
);

export default FilterIcon;